export const havePaidCustomFields = (custom_fields: CustomFieldType[]) =>
  custom_fields
    .filter((cf) => !cf._delete)
    .some((item) => {
      return item.values?.some((value) => Number(value.price) > 0 && !value._delete) && !item._delete;
    });
